if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const targets = document.querySelectorAll('details[is="details-mega"]')
    if (!targets) return;

    targets.forEach(target => {
        const observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.attributeName === "open") {
                    const isOpen = target.hasAttribute("open");

                    if (isOpen) {
                        window.dispatchEvent(new Event("scroll"));
                    }
                }
            }
        });

        observer.observe(target, {
        attributes: true,
        attributeFilter: ["open"]
        });
    });
  }, 300);
}

document.addEventListener("DOMContentLoaded", function() {
    setTimeout(() => {
        const upsellCard = document.querySelector('.horizontal-product__quantity div[bss-b2b-variant-id]')
        const productForm = document.querySelector('[bss-b2b-product-form="quickview"]');

        if (!upsellCard || !productForm) {
            return;
        }

        const variantId = upsellCard.getAttribute('bss-b2b-variant-id')
        console.log('variantId', variantId, productForm)

        const formId = productForm.getAttribute("bss-b2b-product-form-id");
        const product = BSS_B2B.storage.productFormStorage.get(formId);
        if (!product) {
            return;
        }

        console.log('formId', formId, product)

        product.currentVariant = product.variants.find(item => item.id == variantId);
        BSS_B2B.storage.productFormStorage.set(formId, product);

        BSS_B2B?.observer?.productSubject?.notifyObserver?.(
            'VariantChange',
            'VariantSelectChange',
            { productForm }
        );
    }, 2000);
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelectorAll('details[bss-b2b-quickview-product-form]');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "aria-expanded") {
          const isOpen = target.getAttribute("aria-expanded") === "true";

          if (isOpen) {
            const upsellCard = document.querySelector('.horizontal-product__quantity div[bss-b2b-variant-id]')
            const productForm = document.querySelector('[bss-b2b-product-form="quickview"]');

            if (!upsellCard || !productForm) {
                return;
            }

            const variantId = upsellCard.getAttribute('bss-b2b-variant-id')
            console.log('variantId', variantId, productForm)

            const formId = productForm.getAttribute("bss-b2b-product-form-id");
            const product = BSS_B2B.storage.productFormStorage.get(formId);
            if (!product) {
                return;
            }

            console.log('formId', formId, product)

            product.currentVariant = product.variants.find(item => item.id == variantId);
            BSS_B2B.storage.productFormStorage.set(formId, product);

            BSS_B2B?.observer?.productSubject?.notifyObserver?.(
                'VariantChange',
                'VariantSelectChange',
                { productForm }
            );
            console.log("open upsell");
          } else {
            console.log("close upsell");
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-expanded"]
    });
  }, 1000);
}